<form [formGroup]="form">
  @if (showAccommodation) {
    <rc-single-select-form-field
      slot="content"
      label="Accommodation"
      [size]="size"
      [possibleValues]="accommodationValues"
      [formControlName]="accommodationFormFields.accommodation"></rc-single-select-form-field>
    @if (form.controls[accommodationFormFields.accommodation].value === Accommodation.hotel) {
      <rc-string-form-field
        slot="content"
        label="Hotel name"
        [size]="size"
        [formControlName]="accommodationFormFields.hotelName"></rc-string-form-field>
      <rc-string-form-field
        slot="content"
        label="Reservation details"
        [size]="size"
        [formControlName]="accommodationFormFields.reservationDetails"></rc-string-form-field>
    }
    <rc-string-form-field
      slot="content"
      label="Unit number"
      [size]="size"
      [formControlName]="accommodationFormFields.unitNumber"></rc-string-form-field>
  }
  <rc-single-select-form-field
    slot="content"
    [possibleValues]="instructionValues"
    label="Instructions"
    [size]="size"
    [formControlName]="accommodationFormFields.instruction"></rc-single-select-form-field>
  @if (form.controls[accommodationFormFields.instruction].value === Instruction.other) {
    <rc-multi-line-string-form-field
      slot="content"
      label="Details"
      [size]="size"
      [formControlName]="accommodationFormFields.details"></rc-multi-line-string-form-field>
  }
</form>
